import { render } from "./AssignedToMe.vue?vue&type=template&id=5e4ca07c&scoped=true"
import script from "./AssignedToMe.vue?vue&type=script&lang=js"
export * from "./AssignedToMe.vue?vue&type=script&lang=js"

import "./AssignedToMe.vue?vue&type=style&index=0&id=5e4ca07c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e4ca07c"]])

export default __exports__